// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICustomPageable } from './ICustomPageable';
import {
    ICustomPageableFromJSON,
    ICustomPageableFromJSONTyped,
    ICustomPageableToJSON,
    ICustomPageableToJSONTyped,
} from './ICustomPageable';
import type { IFileSearchInfoDto } from './IFileSearchInfoDto';
import {
    IFileSearchInfoDtoFromJSON,
    IFileSearchInfoDtoFromJSONTyped,
    IFileSearchInfoDtoToJSON,
    IFileSearchInfoDtoToJSONTyped,
} from './IFileSearchInfoDto';

/**
 * 
 * @export
 * @interface ICustomPageFileSearchInfoDto
 */
export interface ICustomPageFileSearchInfoDto {
    /**
     * 
     * @type {number}
     * @memberof ICustomPageFileSearchInfoDto
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageFileSearchInfoDto
     */
    size?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageFileSearchInfoDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageFileSearchInfoDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageFileSearchInfoDto
     */
    empty?: boolean;
    /**
     * 
     * @type {Array<IFileSearchInfoDto>}
     * @memberof ICustomPageFileSearchInfoDto
     */
    content?: Array<IFileSearchInfoDto>;
    /**
     * 
     * @type {ICustomPageable}
     * @memberof ICustomPageFileSearchInfoDto
     */
    pageable?: ICustomPageable;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageFileSearchInfoDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageFileSearchInfoDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageFileSearchInfoDto
     */
    total_elements?: number;
}

/**
 * Check if a given object implements the ICustomPageFileSearchInfoDto interface.
 */
export function instanceOfICustomPageFileSearchInfoDto(value: object): value is ICustomPageFileSearchInfoDto {
    return true;
}

export function ICustomPageFileSearchInfoDtoFromJSON(json: any): ICustomPageFileSearchInfoDto {
    return ICustomPageFileSearchInfoDtoFromJSONTyped(json, false);
}

export function ICustomPageFileSearchInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICustomPageFileSearchInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'] == null ? undefined : json['number'],
        'size': json['size'] == null ? undefined : json['size'],
        'last': json['last'] == null ? undefined : json['last'],
        'first': json['first'] == null ? undefined : json['first'],
        'empty': json['empty'] == null ? undefined : json['empty'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IFileSearchInfoDtoFromJSON)),
        'pageable': json['pageable'] == null ? undefined : ICustomPageableFromJSON(json['pageable']),
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
    };
}

export function ICustomPageFileSearchInfoDtoToJSON(json: any): ICustomPageFileSearchInfoDto {
    return ICustomPageFileSearchInfoDtoToJSONTyped(json, false);
}

export function ICustomPageFileSearchInfoDtoToJSONTyped(value?: ICustomPageFileSearchInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'last': value['last'],
        'first': value['first'],
        'empty': value['empty'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IFileSearchInfoDtoToJSON)),
        'pageable': ICustomPageableToJSON(value['pageable']),
        'totalPages': value['total_pages'],
        'numberOfElements': value['number_of_elements'],
        'totalElements': value['total_elements'],
    };
}

